import type React from 'react'

import type { StyledLinkProps } from './StyledLink'
import { StyledLink } from './StyledLink'

export const PrefetchLink: React.FC<StyledLinkProps> = (props) => <StyledLink prefetch {...props} />
